import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useRef } from "react";
import Loader from "../../components/loader";
import NoData from "../../components/noData";
import { useNCallContext } from "../../context/ncall-context";
import { API } from "../../service/api";
import { showErrorToast, showSuccessToast } from "../../utils/toast";
import Table from "../../components/table";
import Modal from "../../components/modal/modal";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../components/modal/confirmationModal";

let config = {
  title: "",
  handler: null,
};

const StatusColorLinkup = () => {
  const { state, dispatch, setOpenModal, openModal, getColors } =
    useNCallContext();
  const confirmationmodalRef = useRef(null);
  const colorNameRef = useRef();
  const statusIdRef = useRef();
  const colorRef = useRef();

  let _id = "";

  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("logged-in-as") == "client") {
      navigate("/client");
    }
  }, []);

  useEffect(() => {
    getColors();
  }, []);

  const openDeletionConfirmationModal = (color) => {
    if (confirmationmodalRef) {
      confirmationmodalRef.current.handleModalOpen();
      confirmationmodalRef.current.setRecordForModal(color);
      confirmationmodalRef.current.setHandlerMethod(() => handleDeleteBtnClk);
    }
  };

  const handleDeleteBtnClk = async (color) => {
    try {
      const res = await API.deleteColor(color.id);
      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
      }
      getColors();
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  const handleUpdateBtnClk = (color) => {
    colorNameRef.current = color.name;
    colorRef.current = color.hexcode;
    statusIdRef.current = color.statusId;
    _id = color.id;
    config = {
      title: "Update Color",
      handler: handleUpdateColor,
    };
    setOpenModal(!openModal);
  };

  const handleAddColor = async () => {
    let data = {
      name: colorNameRef.current.value,
      hexcode: colorRef.current.value,
      statusId: statusIdRef.current.value,
      company_id: "",
    };
    try {
      const res = await API.postColor(data);
      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
      }
      getColors();
    } catch (error) {
      showErrorToast(error.message);
    }
  };
  const handleUpdateColor = async (color) => {
    let data = {
      name: colorNameRef.current.value,
      hexcode: colorRef.current.value,
      statusId: statusIdRef.current.value,
    };
    try {
      const res = await API.putColor(_id, data);
      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
      }
      getColors();
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Code",
        accessor: "hexcode",
        Cell: ({ value }) => {
          return (
            <div className="flex gap-1 justify-start items-center">
              <div className="h-5 w-5" style={{ backgroundColor: value }}></div>
              <div className="uppercase">{value}</div>
            </div>
          );
        },
      },
      {
        Header: "Status Id",
        accessor: "statusId",
      },
    ],
    []
  );
  const actions = [
    {
      icon: PencilIcon,
      handler: handleUpdateBtnClk,
      styles: "w-5 h-5 text-green-500",
    },
    {
      icon: TrashIcon,
      handler: openDeletionConfirmationModal,
      styles: "w-5 h-5 text-red-500",
    },
  ];

  if (state.loading) return <Loader />;

  return (
    <div className="">
      {<ConfirmationModal ref={confirmationmodalRef} />}

      {/* Modal  */}
      {openModal ? (
        <Modal config={config}>
          {/* Department Name */}
          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <label
              htmlFor="department"
              className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
            >
              Color Name
            </label>

            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <input
                ref={colorNameRef}
                required
                defaultValue={colorNameRef.current}
                type="text"
                name="department"
                id="department"
                className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
              />
            </div>
          </div>
          {/* Color */}
          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <label
              htmlFor="department"
              className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
            >
              Color Code
            </label>

            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <input
                type="color"
                ref={colorRef}
                defaultValue={colorRef.value}
                name="color"
                id="color"
                className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
              />
            </div>
          </div>
          {/* Status Id */}
          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <label
              htmlFor="department"
              className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
            >
              Status Id
            </label>

            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <input
                ref={statusIdRef}
                required
                defaultValue={statusIdRef.current}
                type="text"
                name="statusId"
                id="statusId"
                className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
              />
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Ncal Status Colors
          </h1>
        </div>
        <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <button
            onClick={() => {
              config = {
                title: "Add New Color",
                handler: handleAddColor,
              };
              setOpenModal(!openModal);
            }}
            type="button"
            className="block rounded-md bg-indigo-600 py-2 px-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Add Color
          </button>
        </div>
      </div>
      {!state.loading && state.colors.length == 0 ? (
        <NoData message={"You don't have any colors."} />
      ) : (
        <div className="mt-8 flow-root">
          <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <Table
                columns={columns}
                data={state?.colors}
                actions={actions}
                name="colors"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusColorLinkup;
